module.exports = __webpack_public_path__ + "static/media/change_status_club_2.c387cd43.png";